// import React, { useEffect, useState, useCallback } from "react";
// import WSBackButton from "../../../Components/BackButton/BackButton";
// import { Box, Divider, Grid, Paper, Typography, Dialog, DialogContent, DialogTitle, IconButton, Button } from "@mui/material";
// import { useParams } from "react-router-dom";
// import { Controller, useForm } from "react-hook-form";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSHorizontalTimeline from "../../../Components/Timeline/WSHorizontalTimeLine";
// import WSTextField from "../../../Components/TextBox/WSTextBox";
// import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
// import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";
// import LabScanInvoice from "./LabScanInvoice"; // You'll need to create this
// import http from "../../../commonFunctions/httpClient";

// // ✅ SCAN-SPECIFIC INTERFACES
// interface TimelineStep {
//     status: string;
// }

// interface ScanBookingInfo {
//     bookingId: string;
//     bookedOn: string;
//     lab: {
//         labId: string;
//         labName: string;
//     };
//     payment: {
//         method: string;
//         amount: number;
//     };
//     tests: {
//         userId: string;
//         userName: string;
//         testName: string;
//     };
//     slot: {
//         date: string;
//         time: string;
//     };
// }

// interface ScanResult {
//     userId: string;
//     userName: string;
//     resultAvailable: boolean;
//     reportPdfUrl: string | null;
// }

// interface OrderSummary {
//     itemTotal: number;
//     discount: number;
//     totalPayable: number;
//     savings: number;
// }

// interface OrderTracking {
//     orderId: string;
//     trackingId: string;
//     steps: TimelineStep[];
// }
// // ✅ UPDATE your TimelineStep interface
// interface TimelineStep {
//     status: string;
//     label: string;
//     completed: boolean;
//     icon: React.ReactNode;
//     active?: boolean;
// }


// interface ScanBookingDetails {
//     users: Array<{
//         customerProfileId: string;
//         name: string;
//     }>;
//     scanBookingInfo: ScanBookingInfo[];
//     results: ScanResult[];
//     orderSummary: OrderSummary[];
//     orderTracking: OrderTracking[];
// }

// interface ApiResponse {
//     status: boolean;
//     message: string;
//     data: ScanBookingDetails;
// }

// export const LabScanOrderDetails: React.FC<any> = React.memo((props) => {
//     const params = useParams<{ id: string }>();
//     const bookingId = params?.id;

//     const mainForm = useForm<any>();
//     const { control: mainControl, register: mainRegister, handleSubmit: mainHandleSubmit, setValue: mainSetValue, getValues } = mainForm;

//     const [loading, setLoading] = useState<boolean>(false);
//     const [bookingData, setBookingData] = useState<ScanBookingDetails | null>(null);
//     const [error, setError] = useState<string | null>(null);
//     const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);

//     // ✅ File upload states
//     const [reportFiles, setReportFiles] = useState<{ [key: string]: File | null }>({});
//     const [uploadingReports, setUploadingReports] = useState<{ [key: string]: boolean }>({});
//     const [uploadSuccess, setUploadSuccess] = useState<{ [key: string]: boolean }>({});

//     // ✅ Invoice upload states
// const [invoiceFile, setInvoiceFile] = useState<File | null>(null);
// const [uploadingInvoice, setUploadingInvoice] = useState(false);
// const [uploadInvoiceSuccess, setUploadInvoiceSuccess] = useState(false);


//     const handleOpenInvoice = () => {
//         setInvoiceModalOpen(true);
//     };

//     const onSubmit = () => { };

//     // 🔥 FETCH SCAN DATA - YOUR EXACT API
//     useEffect(() => {
//         const fetchData = async () => {
//             if (!bookingId) {
//                 setError("No booking ID found in URL");
//                 return;
//             }

//             setLoading(true);
//             setError(null);

//             try {
//                 console.log(`🔄 Fetching scan data for bookingId: ${bookingId}`);
//                 const response: ApiResponse = await callAPI(
//                     `lab/LabScanBooking/${bookingId}`, // ✅ YOUR SCAN API
//                     Method.GET
//                 );

//                 console.log("📦 SCAN API Response:", response);

//                 if (response?.status === true && response.data) {
//                     console.log("✅ Scan data loaded successfully!");
//                     setBookingData(response.data);
//                     setError(null);
//                 } else {
//                     console.error("❌ Invalid scan response:", response);
//                     setError(`API Error: ${response?.message || "Invalid response structure"}`);
//                 }
//             } catch (err: any) {
//                 console.error("💥 SCAN API Error:", err);
//                 setError(`Failed to fetch: ${err.message || "Network error"}`);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [bookingId]);

//     // ✅ File handlers
//     const handleFileChange = useCallback((userId: string, fieldName: string) => {
//         const fileList = getValues(fieldName) as FileList;
//         if (fileList && fileList.length > 0) {
//             const file = fileList[0];
//             setReportFiles(prev => ({ ...prev, [userId]: file }));
//             console.log(`📁 Selected file for ${userId}:`, file.name);
//         }
//     }, [getValues]);

//     // ✅ FIXED: Update ONLY the handleReportUpload function in your LabScanOrderDetails

// // ✅ REPLACE your handleReportUpload in LabScanOrderDetails with THIS:
// const handleReportUpload = useCallback(async (userId: string, testName: string, fieldName: string) => {
//   if (!bookingId) {  // ✅ Use bookingId from URL params
//     alert(`❌ No booking ID found`);
//     return;
//   }

//   const fileList = getValues(fieldName) as FileList;
//   const file = fileList?.[0];
//   if (!file) {
//     alert(`Please select a report file for ${testName}`);
//     return;
//   }

//   const userIdFromStorage = localStorage.getItem('UserId') || sessionStorage.getItem('UserId');
//   if (!userIdFromStorage) {
//     alert('❌ UserId not found.');
//     return;
//   }

//   const patientKey = userId;
//   setUploadingReports(prev => ({ ...prev, [patientKey]: true }));
//   setUploadSuccess(prev => ({ ...prev, [patientKey]: false }));

//   try {
//     const formData = new FormData();
//     formData.append("ReportFile", file);
//     formData.append("UpdatedBy", userIdFromStorage);

//     console.log('✅ Uploading:', file.name, 'for bookingId:', bookingId);  // ✅ Fixed log

//     // 🔥 CORRECT ENDPOINT: bookingId from URL params (NOT userId)
//     const response = await callAPI(
//       `lab/LabScanBooking/upload-report/${bookingId}`,  // ✅ bookingId, NOT userId
//       Method.PUTFORMDATA,
//       null,
//       null,
//       formData
//     );

//     console.log('✅ Response:', response);

//     if (response?.success === true) {
//       setUploadSuccess(prev => ({ ...prev, [patientKey]: true }));
//       alert(`✅ Report uploaded successfully for ${testName}!`);
//       mainSetValue(fieldName, null as any);
//       setReportFiles(prev => ({ ...prev, [userId]: null }));
//       setTimeout(() => window.location.reload(), 1500);
//     } else {
//       throw new Error(response?.message || 'Upload failed');
//     }

//   } catch (err: any) {
//     console.error('❌ Error:', err);
//     alert(`❌ Failed: ${err?.message || 'Please try again'}`);
//   } finally {
//     setUploadingReports(prev => ({ ...prev, [patientKey]: false }));
//     setTimeout(() => setUploadSuccess(prev => ({ ...prev, [patientKey]: false })), 3000);
//   }
// }, [getValues, mainSetValue, bookingId]);  // ✅ bookingId in deps





// // ✅ Added bookingId dependency


// // ✅ NEW: Invoice Upload Handler
// const handleInvoiceUpload = useCallback(async () => {
//     const file = invoiceFile;
    
//     if (!file) {
//         alert('Please select an invoice file first');
//         return;
//     }

//     if (!bookingId) {
//         alert('No booking ID found');
//         return;
//     }

//     const labId = localStorage.getItem('UserId') || sessionStorage.getItem('UserId');
//     if (!labId) {
//         alert('❌ Lab ID not found. Please login again.');
//         return;
//     }

//     setUploadingInvoice(true);
//     setUploadInvoiceSuccess(false);

//     try {
//         const formData = new FormData();
//         formData.append("file", file);

//         console.log('📤 Uploading invoice:', file.name);

//         const response = await callAPI(
//             `lab/LabScanBooking/${bookingId}/upload-invoice`,
//             Method.POST,
//             formData
//         );

//         console.log('✅ INVOICE UPLOAD Response:', response);

//         // 🔥 FIXED: Check message instead of status
//         if (response?.message === 'Invoice uploaded successfully') {
//             setUploadInvoiceSuccess(true);
//             alert(`✅ Invoice uploaded successfully!`);
//             setInvoiceFile(null);
//             mainSetValue('invoiceFile', null as any);
//             setTimeout(() => window.location.reload(), 1500);
//         } else {
//             throw new Error(response?.message || 'Invoice upload failed');
//         }

//     } catch (err: any) {
//         console.error('❌ Invoice upload error:', err);
//         alert(`❌ Failed to upload invoice: ${err.message || 'Please try again'}`);
//     } finally {
//         setUploadingInvoice(false);
//         setTimeout(() => {
//             setUploadInvoiceSuccess(false);
//         }, 3000);
//     }
// }, [invoiceFile, bookingId, mainSetValue]);

//     useEffect(() => {
//         if (bookingId) {
//             breadCrumbsStore.updateBreadCrumbs([
//                 { "Scan Bookings": "labscan/list" },
//                 { [`Scan Details #${bookingId.slice(-8)}`]: "/" },
//             ]);
//         }
//     }, [bookingId]);

//   // ✅ FINAL PERFECT SOLUTION
// // const steps: TimelineStep[] = bookingData && bookingData.orderTracking[0]?.steps
// //     ? ['Confirmed', 'ReportGenerated', 'InProcess', 'Completed']
// //         .map(status => {
// //             const step = bookingData.orderTracking[0].steps.find((s: any) => s.status === status);
// //             return step ? {
// //                 status: step.status,
// //                 label: step.status.replace('ReportGenerated', 'Report Generated'),
// //                 completed: ['Confirmed', 'ReportGenerated', 'Completed'].includes(step.status),
// //                 icon: <WSIcons.FiPackage />,
// //                 active: step.status === 'InProcess'
// //             } : null as any;
// //         })
// //         .filter(Boolean) as TimelineStep[]
// //     : [];





//     if (loading) {
//         return (
//             <>
//                 <WSBackButton id="btnScheduleBack" url={"/lab-scanning/list"} />
//                 <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
//                     <Typography>Loading scan details for Booking ID: {bookingId}...</Typography>
//                 </Paper>
//             </>
//         );
//     }

//     if (error || !bookingData) {
//         return (
//             <>
//                 <WSBackButton id="btnScheduleBack" url={"/lab-scanning/list"} />
//                 <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px", backgroundColor: "#fff3cd" }}>
//                     <Typography variant="h6" color="warning.main" gutterBottom>No Scan Data Found</Typography>
//                 </Paper>
//             </>
//         );
//     }

//     const firstUser = bookingData.users[0] || { name: "Unknown", customerProfileId: "" };
//     const firstScanInfo = bookingData.scanBookingInfo[0] || {};
//     const firstResult = bookingData.results[0] || { resultAvailable: false, reportPdfUrl: null };
//     const firstOrderSummary = bookingData.orderSummary[0] || { itemTotal: 0, discount: 0, totalPayable: 0, savings: 0 };
//     const firstTracking = bookingData.orderTracking[0] || { trackingId: "", steps: [] };

//     return (
//         <>
//             <WSBackButton id="btnScheduleBack" url={"/labscan/list"} />
//             <form onSubmit={mainHandleSubmit(onSubmit)}>
//                 {/* SCAN TIMELINE */}
//                 <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
//                     <Grid container spacing={2}>
//                         {/* <Grid item sm={12} xs={12}>
//                             <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>📋 Scan Timeline</Typography>
//                         </Grid> */}
//                         {/* <Grid item sm={12} xs={12}>
//                             <WSHorizontalTimeline steps={steps} />
//                             <Typography color={"GrayText"} variant="caption" style={{ fontWeight: 400, marginTop: 10 }}>
//                                 {firstScanInfo.bookedOn}
//                             </Typography>
//                         </Grid> */}
//                     </Grid>
//                 </Paper>

//                 {/* SCAN SUMMARY */}
//                 <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
//                     <Grid container spacing={2} mt={2}>
//                         <Grid item sm={4} xs={12}><Typography>Booking ID</Typography></Grid>
//                         <Grid item sm={4} xs={12}><Typography>Status</Typography></Grid>
//                         <Grid item sm={4} xs={12}><Typography>Tracking ID</Typography></Grid>
//                         <Grid item xs={12}><Divider style={{ marginTop: 10 }} /></Grid>
//                         <Grid item sm={4} xs={12}><Typography>{firstScanInfo.bookingId}</Typography></Grid>
//                         <Grid item sm={4} xs={12}>
//                             <Typography fontWeight="bold" color={firstResult.resultAvailable ? "success.main" : "warning.main"}>
//                                 {firstResult.resultAvailable ? "Report Ready" : "Pending"}
//                             </Typography>
//                         </Grid>
//                         <Grid item xs={12} sm={3}>
//                             <Typography>{firstTracking.trackingId}</Typography>
//                         </Grid>
//                     </Grid>
//                 </Paper>

//                 {/* CUSTOMER & SCAN INFO */}
//                 <Grid container spacing={2} mt={2} sx={{ alignItems: 'stretch' }}>
//                     <Grid item xs={12} sm={6}>
//                         <Paper elevation={0} sx={{ padding: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
//                             <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>👤 Customer Information</Typography>
//                             <Grid container spacing={2}>
//                                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Customer Name</Typography></Grid>
//                                 <Grid item xs={12} sm={8}><Typography variant="body2">: {firstUser.name}</Typography></Grid>
//                                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Customer ID</Typography></Grid>
//                                 <Grid item xs={12} sm={8}><Typography variant="body2">: {firstUser.customerProfileId}</Typography></Grid>
//                                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Lab Name</Typography></Grid>
//                                 <Grid item xs={12} sm={8}><Typography variant="body2">: {firstScanInfo.lab?.labName}</Typography></Grid>
//                                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Booking Date</Typography></Grid>
//                                 <Grid item xs={12} sm={8}><Typography variant="body2">: {new Date(firstScanInfo.bookedOn).toLocaleString()}</Typography></Grid>
//                             </Grid>
//                         </Paper>
//                     </Grid>

//                     <Grid item xs={12} sm={6}>
//                         <Paper elevation={0} sx={{ padding: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
//                             <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>📋 Scan Information</Typography>
//                             <Grid container spacing={2}>
//                                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Scan Name</Typography></Grid>
//                                 <Grid item xs={12} sm={8}><Typography variant="body2">: {firstScanInfo.tests?.testName}</Typography></Grid>
//                                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Slot Date</Typography></Grid>
//                                 <Grid item xs={12} sm={8}><Typography variant="body2">: {firstScanInfo.slot?.date?.split('T')[0]}</Typography></Grid>
//                                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Slot Time</Typography></Grid>
//                                 <Grid item xs={12} sm={8}><Typography variant="body2">: {firstScanInfo.slot?.time}</Typography></Grid>
//                                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Payment Method</Typography></Grid>
//                                 <Grid item xs={12} sm={8}><Typography variant="body2">: {firstScanInfo.payment?.method}</Typography></Grid>
//                             </Grid>
//                         </Paper>
//                     </Grid>
//                 </Grid>

//                 {/* ✅ SCAN REPORT SECTION */}
//                 <Grid container spacing={2} mt={2}>
//                     <Grid item xs={12}>
//                         <Paper elevation={0} sx={{ padding: 3, borderRadius: "8px" }}>
//                             <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>
//                                 🩻 Scan Report Information
//                             </Typography>

//                             {bookingData.scanBookingInfo.map((scanInfo, index) => {
//                                 const result = bookingData.results[index] || { resultAvailable: false, reportPdfUrl: null };
//                                 const fieldName = `report_${scanInfo.tests?.userId}`;

//                                 return (
//                                     <Grid container key={scanInfo.bookingId} spacing={1} sx={{ pl: 3, mb: 2, pt: 1 }}>
//                                         {/* Scan Info */}
//                                         <Grid item xs={12} sm={3}>
//                                             <Typography variant="body2" color="GrayText" sx={{ fontSize: '0.85rem' }}>Scan:</Typography>
//                                         </Grid>
//                                         <Grid item xs={12} sm={9}>
//                                             <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>{scanInfo.tests?.testName}</Typography>
//                                         </Grid>

//                                         {/* <Grid item xs={12} sm={3}>
//                                             <Typography variant="body2" color="GrayText" sx={{ fontSize: '0.85rem' }}>Status:</Typography>
//                                         </Grid> */}
//                                         {/* <Grid item xs={12} sm={9}>
//                                             <Typography variant="body2" sx={{ fontSize: '0.9rem', fontWeight: 'medium', color: result.resultAvailable ? "success.main" : "warning.main" }}>
//                                                 {result.resultAvailable ? 'Report Available' : 'Report Pending'}
//                                             </Typography>
//                                         </Grid> */}

//                                         {/* Existing Report */}
//                                         {result.reportPdfUrl && (
//                                             <>
//                                                 <Grid item xs={12} sm={3}>
//                                                     <Typography variant="body2" color="GrayText" sx={{ fontSize: '0.85rem' }}>Report:</Typography>
//                                                 </Grid>
//                                                 <Grid item xs={12} sm={9}>
//                                                     <Typography
//                                                         variant="body2"
//                                                         sx={{ fontSize: '0.9rem', color: "#098963", cursor: "pointer", textDecoration: "underline", '&:hover': { color: "#0a7a52" } }}
//                                                         onClick={() => window.open(result.reportPdfUrl!, '_blank')}
//                                                     >
//                                                         📄 View Report
//                                                     </Typography>
//                                                 </Grid>
//                                             </>
//                                         )}

//                                         {/* File Upload */}
//                                         <Grid item xs={12}>
//                                             <Divider sx={{ my: 1 }} />
//                                             <Typography variant="body2" color="GrayText" sx={{ fontSize: '0.85rem', mt: 1 }}>
//                                                 Upload New Report:
//                                             </Typography>
//                                             <Grid container spacing={2} sx={{ mt: 1 }}>
//                                                 <Grid item xs={12} sm={8}>
//                                                     <WSFileUpload
//                                                         control={mainControl}
//                                                         name={fieldName}
//                                                         label="Select Scan Report (PDF/JPG/PNG)"
//                                                         id={fieldName}
//                                                         rules={{ required: false }}
//                                                         onChange={() => handleFileChange(scanInfo.tests?.userId || '', fieldName)}
//                                                     />
//                                                     {reportFiles[scanInfo.tests?.userId || ''] && (
//                                                         <Typography variant="caption" color="success.main" sx={{ mt: 1, display: 'block', fontSize: '0.8rem' }}>
//                                                             ✅ Selected: {reportFiles[scanInfo.tests?.userId || '']?.name}
//                                                         </Typography>
//                                                     )}
//                                                 </Grid>
//                                                 <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'flex-end' }}>
//                                                     <Button
//                                                         variant="contained"
//                                                         color="primary"
//                                                         onClick={() => handleReportUpload(scanInfo.tests?.userId || '', scanInfo.tests?.testName || '', fieldName)}
//                                                         disabled={uploadingReports[scanInfo.tests?.userId || ''] || !reportFiles[scanInfo.tests?.userId || '']}
//                                                         sx={{ mt: 1.5 }}
//                                                     >
//                                                         {uploadingReports[scanInfo.tests?.userId || '']
//                                                             ? "⏳ Uploading..."
//                                                             : "🚀 Upload Report"
//                                                         }
//                                                     </Button>
//                                                     {uploadSuccess[scanInfo.tests?.userId || ''] && (
//                                                         <Typography color="success.main" sx={{ ml: 2, fontSize: '0.8rem', alignSelf: 'center' }}>
//                                                             ✓ Success
//                                                         </Typography>
//                                                     )}
//                                                 </Grid>
//                                             </Grid>
//                                         </Grid>
//                                     </Grid>
//                                 );
//                             })}
//                         </Paper>
//                     </Grid>
//                 </Grid>

//                 {/* PAYMENT INFORMATION */}
//                 <Grid container spacing={2} mt={3}>
//                     <Grid item xs={12} sm={6}>
//                         <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 0, paddingBottom: 25, borderRadius: "8px", height: "24rem" }}>
//                             <Grid container spacing={2} mt={0}>
//                                 <Grid item sm={12} xs={12}>
//                                     <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>💰 Payment Information</Typography>
//                                 </Grid>
//                                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Payment Method</Typography></Grid>
//                                 <Grid item xs={12} sm={8}><Typography variant="body2" mt={2}>: {firstScanInfo.payment?.method}</Typography></Grid>
//                                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Item Total</Typography></Grid>
//                                 <Grid item xs={12} sm={8}><Typography variant="body2" mt={2}>: ₹{firstOrderSummary.itemTotal?.toFixed(2)}/-</Typography></Grid>
//                                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Discount</Typography></Grid>
//                                 <Grid item xs={12} sm={8}><Typography variant="body2" mt={2}>: ₹{firstOrderSummary.discount?.toFixed(2)}/-</Typography></Grid>
//                                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Total Payable</Typography></Grid>
//                                 <Grid item xs={12} sm={8}><Typography variant="body2" fontWeight="bold" mt={2}>: ₹{firstOrderSummary.totalPayable?.toFixed(2)}/-</Typography></Grid>
//                                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Savings</Typography></Grid>
//                                 <Grid item xs={12} sm={8}><Typography variant="body2" mt={2}>: ₹{firstOrderSummary.savings?.toFixed(2)}/-</Typography></Grid>
//                                 <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Invoice</Typography></Grid>
//                                 <Grid item xs={12} sm={8}>
//                                     <Typography
//                                         style={{ color: "#098963", cursor: "pointer", textDecoration: "underline" }}
//                                         mt={2}
//                                         onClick={handleOpenInvoice}
//                                     >
//                                         📋 View Invoice
//                                     </Typography>
//                                 </Grid>
//                             </Grid>
//                         </Paper>
//                     </Grid>
//                 </Grid>
//             </form>

//             {/* Invoice Modal */}
//             <Dialog open={invoiceModalOpen} onClose={() => setInvoiceModalOpen(false)} maxWidth="lg" fullWidth PaperProps={{ sx: { height: "90vh" } }}>
//                 <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                     <Typography variant="h6">Scan Invoice</Typography>
//                     <IconButton onClick={() => setInvoiceModalOpen(false)}>
//                         <WSIcons.CloseIcon />
//                     </IconButton>
//                 </DialogTitle>
//                 <DialogContent sx={{ p: 0, height: "100%", overflow: "auto" }}>
//                     {bookingId && <LabScanInvoice bookingId={bookingId} />}
//                 </DialogContent>
//             </Dialog>

//             {/* ✅ NEW: INVOICE UPLOAD SECTION */}
// {/* ✅ FIXED: INVOICE UPLOAD SECTION */}
// <Grid container spacing={2} mt={3}>
//     <Grid item xs={12}>
//         <Paper elevation={0} sx={{ padding: 3, borderRadius: "8px" }}>
//             <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>
//                 💼 Invoice Upload
//             </Typography>
            
//             <Grid container spacing={2}>
//                 <Grid item xs={12} sm={8}>
//                     <WSFileUpload
//     control={mainControl}
//     name="invoiceFile"
//     label="Select Invoice (PDF/JPG/PNG)"
//     id="invoiceFile"
//     rules={{ required: false }}
//     onChange={(files: File[] | null) => {
//         if (files && files.length > 0) {
//             const file = files[0];
//             setInvoiceFile(file);
//             console.log('📁 Selected invoice:', file.name);
//         }
//     }}
// />

//                     {invoiceFile && (
//                         <Typography variant="caption" color="success.main" sx={{ mt: 1, display: 'block', fontSize: '0.8rem' }}>
//                             ✅ Selected: {invoiceFile.name}
//                         </Typography>
//                     )}
//                 </Grid>
//                 <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'flex-end' }}>
//                     <Button
//                         variant="contained"
//                         color="secondary"
//                         onClick={handleInvoiceUpload}
//                         disabled={uploadingInvoice || !invoiceFile}
//                         sx={{ mt: 1.5 }}
//                         fullWidth
//                     >
//                         {uploadingInvoice
//                             ? "⏳ Uploading Invoice..."
//                             : "🚀 Upload Invoice"
//                         }
//                     </Button>
//                     {uploadInvoiceSuccess && (
//                         <Typography color="success.main" sx={{ ml: 2, fontSize: '0.8rem', alignSelf: 'center' }}>
//                             ✓ Success
//                         </Typography>
//                     )}
//                 </Grid>
//             </Grid>
//         </Paper>
//     </Grid>
// </Grid>


//         </>
//     );
// });

// export default LabScanOrderDetails;



import React, { useEffect, useState, useCallback } from "react";
import WSBackButton from "../../../Components/BackButton/BackButton";
import { Box, Divider, Grid, Paper, Typography, Dialog, DialogContent, DialogTitle, IconButton, Button } from "@mui/material";
import { useParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSHorizontalTimeline from "../../../Components/Timeline/WSHorizontalTimeLine";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import WSFileUpload from "../../../Components/FileUpload/WSFileUpload";
import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";
import LabScanInvoice from "./LabScanInvoice";
import http from "../../../commonFunctions/httpClient";
import configData from '../../../Config/config.json'; // ✅ ADDED

// ✅ UTILITY FUNCTIONS - EXACT COPY FROM LabOrderDetails
const imgUrl = configData.imgUrl;
const getCorrectedReportUrl = (reportUrl: string) => {
  return reportUrl.replace(/^UploadedImages\//, '');
};

// ✅ SCAN-SPECIFIC INTERFACES
interface TimelineStep {
    status: string;
}

interface ScanBookingInfo {
    bookingId: string;
    bookedOn: string;
    lab: {
        labId: string;
        labName: string;
    };
    payment: {
        method: string;
        amount: number;
    };
    tests: {
        userId: string;
        userName: string;
        testName: string;
    };
    slot: {
        date: string;
        time: string;
    };
}

interface ScanResult {
    userId: string;
    userName: string;
    resultAvailable: boolean;
    reportPdfUrl: string | null;
}

interface OrderSummary {
    itemTotal: number;
    discount: number;
    totalPayable: number;
    savings: number;
}

interface OrderTracking {
    orderId: string;
    trackingId: string;
    steps: TimelineStep[];
}
interface TimelineStep {
    status: string;
    label: string;
    completed: boolean;
    icon: React.ReactNode;
    active?: boolean;
}

interface ScanBookingDetails {
    users: Array<{
        customerProfileId: string;
        name: string;
    }>;
    scanBookingInfo: ScanBookingInfo[];
    results: ScanResult[];
    orderSummary: OrderSummary[];
    orderTracking: OrderTracking[];
}

interface ApiResponse {
    status: boolean;
    message: string;
    data: ScanBookingDetails;
}

export const LabScanOrderDetails: React.FC<any> = React.memo((props) => {
    const params = useParams<{ id: string }>();
    const bookingId = params?.id;

    const mainForm = useForm<any>();
    const { control: mainControl, register: mainRegister, handleSubmit: mainHandleSubmit, setValue: mainSetValue, getValues } = mainForm;

    const [loading, setLoading] = useState<boolean>(false);
    const [bookingData, setBookingData] = useState<ScanBookingDetails | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);

    // ✅ File upload states
    const [reportFiles, setReportFiles] = useState<{ [key: string]: File | null }>({});
    const [uploadingReports, setUploadingReports] = useState<{ [key: string]: boolean }>({});
    const [uploadSuccess, setUploadSuccess] = useState<{ [key: string]: boolean }>({});

    // ✅ Invoice upload states
    const [invoiceFile, setInvoiceFile] = useState<File | null>(null);
    const [uploadingInvoice, setUploadingInvoice] = useState(false);
    const [uploadInvoiceSuccess, setUploadInvoiceSuccess] = useState(false);

    const handleOpenInvoice = () => {
        setInvoiceModalOpen(true);
    };

    const onSubmit = () => { };

    // 🔥 FETCH SCAN DATA - YOUR EXACT API
    useEffect(() => {
        const fetchData = async () => {
            if (!bookingId) {
                setError("No booking ID found in URL");
                return;
            }

            setLoading(true);
            setError(null);

            try {
                console.log(`🔄 Fetching scan data for bookingId: ${bookingId}`);
                const response: ApiResponse = await callAPI(
                    `lab/LabScanBooking/${bookingId}`,
                    Method.GET
                );

                console.log("📦 SCAN API Response:", response);

                if (response?.status === true && response.data) {
                    console.log("✅ Scan data loaded successfully!");
                    setBookingData(response.data);
                    setError(null);
                } else {
                    console.error("❌ Invalid scan response:", response);
                    setError(`API Error: ${response?.message || "Invalid response structure"}`);
                }
            } catch (err: any) {
                console.error("💥 SCAN API Error:", err);
                setError(`Failed to fetch: ${err.message || "Network error"}`);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [bookingId]);

    // ✅ File handlers
    const handleFileChange = useCallback((userId: string, fieldName: string) => {
        const fileList = getValues(fieldName) as FileList;
        if (fileList && fileList.length > 0) {
            const file = fileList[0];
            setReportFiles(prev => ({ ...prev, [userId]: file }));
            console.log(`📁 Selected file for ${userId}:`, file.name);
        }
    }, [getValues]);

    const handleReportUpload = useCallback(async (userId: string, testName: string, fieldName: string) => {
        if (!bookingId) {
            alert(`❌ No booking ID found`);
            return;
        }

        const fileList = getValues(fieldName) as FileList;
        const file = fileList?.[0];
        if (!file) {
            alert(`Please select a report file for ${testName}`);
            return;
        }

        const userIdFromStorage = localStorage.getItem('UserId') || sessionStorage.getItem('UserId');
        if (!userIdFromStorage) {
            alert('❌ UserId not found.');
            return;
        }

        const patientKey = userId;
        setUploadingReports(prev => ({ ...prev, [patientKey]: true }));
        setUploadSuccess(prev => ({ ...prev, [patientKey]: false }));

        try {
            const formData = new FormData();
            formData.append("ReportFile", file);
            formData.append("UpdatedBy", userIdFromStorage);

            console.log('✅ Uploading:', file.name, 'for bookingId:', bookingId);

            const response = await callAPI(
                `lab/LabScanBooking/upload-report/${bookingId}`,
                Method.PUTFORMDATA,
                null,
                null,
                formData
            );

            console.log('✅ Response:', response);

            if (response?.success === true) {
                setUploadSuccess(prev => ({ ...prev, [patientKey]: true }));
                alert(`✅ Report uploaded successfully for ${testName}!`);
                mainSetValue(fieldName, null as any);
                setReportFiles(prev => ({ ...prev, [userId]: null }));
                setTimeout(() => window.location.reload(), 1500);
            } else {
                throw new Error(response?.message || 'Upload failed');
            }

        } catch (err: any) {
            console.error('❌ Error:', err);
            alert(`❌ Failed: ${err?.message || 'Please try again'}`);
        } finally {
            setUploadingReports(prev => ({ ...prev, [patientKey]: false }));
            setTimeout(() => setUploadSuccess(prev => ({ ...prev, [patientKey]: false })), 3000);
        }
    }, [getValues, mainSetValue, bookingId]);

    const handleInvoiceUpload = useCallback(async () => {
        const file = invoiceFile;
        
        if (!file) {
            alert('Please select an invoice file first');
            return;
        }

        if (!bookingId) {
            alert('No booking ID found');
            return;
        }

        const labId = localStorage.getItem('UserId') || sessionStorage.getItem('UserId');
        if (!labId) {
            alert('❌ Lab ID not found. Please login again.');
            return;
        }

        setUploadingInvoice(true);
        setUploadInvoiceSuccess(false);

        try {
            const formData = new FormData();
            formData.append("file", file);

            console.log('📤 Uploading invoice:', file.name);

            const response = await callAPI(
                `lab/LabScanBooking/${bookingId}/upload-invoice`,
                Method.POST,
                formData
            );

            console.log('✅ INVOICE UPLOAD Response:', response);

            if (response?.message === 'Invoice uploaded successfully') {
                setUploadInvoiceSuccess(true);
                alert(`✅ Invoice uploaded successfully!`);
                setInvoiceFile(null);
                mainSetValue('invoiceFile', null as any);
                setTimeout(() => window.location.reload(), 1500);
            } else {
                throw new Error(response?.message || 'Invoice upload failed');
            }

        } catch (err: any) {
            console.error('❌ Invoice upload error:', err);
            alert(`❌ Failed to upload invoice: ${err.message || 'Please try again'}`);
        } finally {
            setUploadingInvoice(false);
            setTimeout(() => {
                setUploadInvoiceSuccess(false);
            }, 3000);
        }
    }, [invoiceFile, bookingId, mainSetValue]);

    useEffect(() => {
        if (bookingId) {
            breadCrumbsStore.updateBreadCrumbs([
                { "Scan Bookings": "labscan/list" },
                { [`Scan Details #${bookingId.slice(-8)}`]: "/" },
            ]);
        }
    }, [bookingId]);

    if (loading) {
        return (
            <>
                <WSBackButton id="btnScheduleBack" url={"/lab-scanning/list"} />
                <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px" }}>
                    <Typography>Loading scan details for Booking ID: {bookingId}...</Typography>
                </Paper>
            </>
        );
    }

    if (error || !bookingData) {
        return (
            <>
                <WSBackButton id="btnScheduleBack" url={"/lab-scanning/list"} />
                <Paper style={{ padding: 20, marginTop: 20, borderRadius: "8px", backgroundColor: "#fff3cd" }}>
                    <Typography variant="h6" color="warning.main" gutterBottom>No Scan Data Found</Typography>
                </Paper>
            </>
        );
    }

    const firstUser = bookingData.users[0] || { name: "Unknown", customerProfileId: "" };
    const firstScanInfo = bookingData.scanBookingInfo[0] || {};
    const firstResult = bookingData.results[0] || { resultAvailable: false, reportPdfUrl: null };
    const firstOrderSummary = bookingData.orderSummary[0] || { itemTotal: 0, discount: 0, totalPayable: 0, savings: 0 };
    const firstTracking = bookingData.orderTracking[0] || { trackingId: "", steps: [] };

    return (
        <>
            <WSBackButton id="btnScheduleBack" url={"/labscan/list"} />
            <form onSubmit={mainHandleSubmit(onSubmit)}>
                {/* SCAN TIMELINE */}
                <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
                    <Grid container spacing={2}>
                        {/* Timeline content commented out - keeping your original */}
                    </Grid>
                </Paper>

                {/* SCAN SUMMARY */}
                <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 20, paddingBottom: 25, borderRadius: "8px" }}>
                    <Grid container spacing={2} mt={2}>
                        <Grid item sm={4} xs={12}><Typography>Booking ID</Typography></Grid>
                        <Grid item sm={4} xs={12}><Typography>Status</Typography></Grid>
                        <Grid item sm={4} xs={12}><Typography>Tracking ID</Typography></Grid>
                        <Grid item xs={12}><Divider style={{ marginTop: 10 }} /></Grid>
                        <Grid item sm={4} xs={12}><Typography>{firstScanInfo.bookingId}</Typography></Grid>
                        <Grid item sm={4} xs={12}>
                            <Typography fontWeight="bold" color={firstResult.resultAvailable ? "success.main" : "warning.main"}>
                                {firstResult.resultAvailable ? "Report Ready" : "Pending"}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Typography>{firstTracking.trackingId}</Typography>
                        </Grid>
                    </Grid>
                </Paper>

                {/* CUSTOMER & SCAN INFO */}
                <Grid container spacing={2} mt={2} sx={{ alignItems: 'stretch' }}>
                    <Grid item xs={12} sm={6}>
                        <Paper elevation={0} sx={{ padding: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>👤 Customer Information</Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Customer Name</Typography></Grid>
                                <Grid item xs={12} sm={8}><Typography variant="body2">: {firstUser.name}</Typography></Grid>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Customer ID</Typography></Grid>
                                <Grid item xs={12} sm={8}><Typography variant="body2">: {firstUser.customerProfileId}</Typography></Grid>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Lab Name</Typography></Grid>
                                <Grid item xs={12} sm={8}><Typography variant="body2">: {firstScanInfo.lab?.labName}</Typography></Grid>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Booking Date</Typography></Grid>
                                <Grid item xs={12} sm={8}><Typography variant="body2">: {new Date(firstScanInfo.bookedOn).toLocaleString()}</Typography></Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Paper elevation={0} sx={{ padding: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>📋 Scan Information</Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Scan Name</Typography></Grid>
                                <Grid item xs={12} sm={8}><Typography variant="body2">: {firstScanInfo.tests?.testName}</Typography></Grid>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Slot Date</Typography></Grid>
                                <Grid item xs={12} sm={8}><Typography variant="body2">: {firstScanInfo.slot?.date?.split('T')[0]}</Typography></Grid>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Slot Time</Typography></Grid>
                                <Grid item xs={12} sm={8}><Typography variant="body2">: {firstScanInfo.slot?.time}</Typography></Grid>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText">Payment Method</Typography></Grid>
                                <Grid item xs={12} sm={8}><Typography variant="body2">: {firstScanInfo.payment?.method}</Typography></Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>

                {/* ✅ SCAN REPORT SECTION - FIXED WITH EXACT LabOrderDetails PATTERN */}
                <Grid container spacing={2} mt={2}>
                    <Grid item xs={12}>
                        <Paper elevation={0} sx={{ padding: 3, borderRadius: "8px" }}>
                            <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>
                                🩻 Scan Report Information
                            </Typography>

                            {bookingData.scanBookingInfo.map((scanInfo, index) => {
                                const result = bookingData.results[index] || { resultAvailable: false, reportPdfUrl: null };
                                const fieldName = `report_${scanInfo.tests?.userId}`;

                                return (
                                    <Grid container key={scanInfo.bookingId} spacing={1} sx={{ pl: 3, mb: 2, pt: 1 }}>
                                        {/* Scan Info */}
                                        <Grid item xs={12} sm={3}>
                                            <Typography variant="body2" color="GrayText" sx={{ fontSize: '0.85rem' }}>Scan:</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={9}>
                                            <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>{scanInfo.tests?.testName}</Typography>
                                        </Grid>

                                        {/* 🔥 EXACT LabOrderDetails REPORT VIEW IMPLEMENTATION */}
                                        {result.reportPdfUrl && (
                                            <>
                                                <Grid item xs={12} sm={3}>
                                                    <Typography variant="body2" color="GrayText" sx={{ fontSize: '0.85rem' }}>Report:</Typography>
                                                </Grid>
                                                <Grid item xs={12} sm={9}>
                                                    <Typography 
                                                        variant="body2"
                                                        sx={{ 
                                                            fontSize: '0.9rem', 
                                                            color: "#098963", 
                                                            cursor: "pointer", 
                                                            textDecoration: "underline", 
                                                            '&:hover': { color: "#0a7a52" } 
                                                        }}
                                                        onClick={() => {
                                                            const filename = getCorrectedReportUrl(result.reportPdfUrl!);
                                                            const pdfUrl = `${imgUrl}/${filename}`;
                                                            console.log('📄 ScanReport style - Opening:', pdfUrl);
                                                            
                                                            const newWindow = window.open(pdfUrl, '_blank', 'noopener,noreferrer');
                                                            if (!newWindow) {
                                                                alert('Please allow popups to view the report');
                                                            }
                                                        }}
                                                    >
                                                        📄 View Report
                                                    </Typography>
                                                </Grid>
                                            </>
                                        )}

                                        {/* File Upload */}
                                        <Grid item xs={12}>
                                            <Divider sx={{ my: 1 }} />
                                            <Typography variant="body2" color="GrayText" sx={{ fontSize: '0.85rem', mt: 1 }}>
                                                Upload New Report:
                                            </Typography>
                                            <Grid container spacing={2} sx={{ mt: 1 }}>
                                                <Grid item xs={12} sm={8}>
                                                    <WSFileUpload
                                                        control={mainControl}
                                                        name={fieldName}
                                                        label="Select Scan Report (PDF/JPG/PNG)"
                                                        id={fieldName}
                                                        rules={{ required: false }}
                                                        onChange={() => handleFileChange(scanInfo.tests?.userId || '', fieldName)}
                                                    />
                                                    {reportFiles[scanInfo.tests?.userId || ''] && (
                                                        <Typography variant="caption" color="success.main" sx={{ mt: 1, display: 'block', fontSize: '0.8rem' }}>
                                                            ✅ Selected: {reportFiles[scanInfo.tests?.userId || '']?.name}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => handleReportUpload(scanInfo.tests?.userId || '', scanInfo.tests?.testName || '', fieldName)}
                                                        disabled={uploadingReports[scanInfo.tests?.userId || ''] || !reportFiles[scanInfo.tests?.userId || '']}
                                                        sx={{ mt: 1.5 }}
                                                    >
                                                        {uploadingReports[scanInfo.tests?.userId || '']
                                                            ? "⏳ Uploading..."
                                                            : "🚀 Upload Report"
                                                        }
                                                    </Button>
                                                    {uploadSuccess[scanInfo.tests?.userId || ''] && (
                                                        <Typography color="success.main" sx={{ ml: 2, fontSize: '0.8rem', alignSelf: 'center' }}>
                                                            ✓ Success
                                                        </Typography>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                );
                            })}
                        </Paper>
                    </Grid>
                </Grid>

                {/* PAYMENT INFORMATION */}
                <Grid container spacing={2} mt={3}>
                    <Grid item xs={12} sm={6}>
                        <Paper elevation={0} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 0, paddingBottom: 25, borderRadius: "8px", height: "24rem" }}>
                            <Grid container spacing={2} mt={0}>
                                <Grid item sm={12} xs={12}>
                                    <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>💰 Payment Information</Typography>
                                </Grid>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Payment Method</Typography></Grid>
                                <Grid item xs={12} sm={8}><Typography variant="body2" mt={2}>: {firstScanInfo.payment?.method}</Typography></Grid>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Item Total</Typography></Grid>
                                <Grid item xs={12} sm={8}><Typography variant="body2" mt={2}>: ₹{firstOrderSummary.itemTotal?.toFixed(2)}/-</Typography></Grid>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Discount</Typography></Grid>
                                <Grid item xs={12} sm={8}><Typography variant="body2" mt={2}>: ₹{firstOrderSummary.discount?.toFixed(2)}/-</Typography></Grid>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Total Payable</Typography></Grid>
                                <Grid item xs={12} sm={8}><Typography variant="body2" fontWeight="bold" mt={2}>: ₹{firstOrderSummary.totalPayable?.toFixed(2)}/-</Typography></Grid>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Savings</Typography></Grid>
                                <Grid item xs={12} sm={8}><Typography variant="body2" mt={2}>: ₹{firstOrderSummary.savings?.toFixed(2)}/-</Typography></Grid>
                                <Grid item xs={12} sm={4}><Typography variant="body2" color="GrayText" mt={2}>Invoice</Typography></Grid>
                                <Grid item xs={12} sm={8}>
                                    <Typography
                                        style={{ color: "#098963", cursor: "pointer", textDecoration: "underline" }}
                                        mt={2}
                                        onClick={handleOpenInvoice}
                                    >
                                        📋 View Invoice
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>

                    {/* ✅ FIXED: INVOICE UPLOAD SECTION - MOVED INSIDE Grid container */}
                    <Grid item xs={12} sm={6}>
                        <Paper elevation={0} sx={{ padding: 3, borderRadius: "8px", height: "100%" }}>
                            <Typography sx={{ fontSize: "1rem", fontWeight: "bold", mb: 2 }}>
                                💼 Invoice Upload
                            </Typography>
                            
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <WSFileUpload
                                        control={mainControl}
                                        name="invoiceFile"
                                        label="Select Invoice (PDF/JPG/PNG)"
                                        id="invoiceFile"
                                        rules={{ required: false }}
                                        onChange={(files: File[] | null) => {
                                            if (files && files.length > 0) {
                                                const file = files[0];
                                                setInvoiceFile(file);
                                                console.log('📁 Selected invoice:', file.name);
                                            }
                                        }}
                                    />

                                    {invoiceFile && (
                                        <Typography variant="caption" color="success.main" sx={{ mt: 1, display: 'block', fontSize: '0.8rem' }}>
                                            ✅ Selected: {invoiceFile.name}
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid item xs={12} sx={{ display: 'flex', alignItems: 'flex-end' }}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={handleInvoiceUpload}
                                        disabled={uploadingInvoice || !invoiceFile}
                                        sx={{ mt: 1.5 }}
                                        fullWidth
                                    >
                                        {uploadingInvoice
                                            ? "⏳ Uploading Invoice..."
                                            : "🚀 Upload Invoice"
                                        }
                                    </Button>
                                    {uploadInvoiceSuccess && (
                                        <Typography color="success.main" sx={{ ml: 2, fontSize: '0.8rem', alignSelf: 'center' }}>
                                            ✓ Success
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </form>

            {/* Invoice Modal */}
            <Dialog open={invoiceModalOpen} onClose={() => setInvoiceModalOpen(false)} maxWidth="lg" fullWidth PaperProps={{ sx: { height: "90vh" } }}>
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant="h6">Scan Invoice</Typography>
                    <IconButton onClick={() => setInvoiceModalOpen(false)}>
                        <WSIcons.CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 0, height: "100%", overflow: "auto" }}>
                    {bookingId && <LabScanInvoice bookingId={bookingId} />}
                </DialogContent>
            </Dialog>
        </>
    );
});

export default LabScanOrderDetails;
